<template>
  <div class="system-auth-container">
    <div class="table-prefix-box">
      <div class="btn-box">
        <el-button-group class="mr-10">
          <el-button @click="showDialog" title="新增" size="mini"
                     type="primary" icon="el-icon-plus">新增
          </el-button>
          <el-button @click="clickEdit" title="编辑" size="mini"
                     type="primary" icon="el-icon-edit">编辑
          </el-button>
          <el-button @click="del" size="mini"
                     type="primary" icon="el-icon-delete">删除
          </el-button>
        </el-button-group>
      </div>
      <div class="search-box mt-15"></div>
    </div>

    <div class="table mt-15">
      <el-table v-loading="tableLoading" border ref="table" :data="list" highlight-current-row
                @current-change="handleCurrentChange" style="width:100%">
        <el-table-column label="ID" width="100">
          <template slot-scope="scope"><span>12</span></template>
        </el-table-column>
        <el-table-column label="名称">
          <template slot-scope="scope"><span>权限状态修改</span></template>
        </el-table-column>
        <el-table-column label="URL">
          <template slot-scope="scope"><span>/api/admin_auth/edit_status</span></template>
        </el-table-column>
        <el-table-column label="排序" width="100">
          <template slot-scope="scope">
            <el-input size="mini" type="number" :max="1000" v-model="scope.row.sort"
                      @change="changeOrder(scope.$index)"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="字段待定">
          <template slot-scope="scope"><span>字段待定</span></template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog title="添加" width="400px" :visible.sync="dialogShow">
      <div style="font-size:13px;">
        <el-input class="display-inline width100" v-model="obj.title" placeholder="请填写名称，比如 “微信接口”"
                  size="mini"></el-input>
        <el-input class="display-inline width100 mt-15" v-model="obj.url"
                  placeholder="请填写Url，格式“/api/admin_login/login”" size="mini"></el-input>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogShow=false">取 消</el-button>
        <el-button size="mini" type="primary" @click="submit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
  import {tool} from "../../common/js/tool.js";
  import {Loading} from "element-ui";
  export default {
    data() {
      return {
        dialogShow: false,
        obj: {
          title: "",
          url: ""
        },
        list: [
          {sort: 1},
          {sort: 2},
          {sort: 3},
          {sort: 4},
          {sort: 6},
          {sort: 7},
          {sort: 9},
          {sort: 11},
          {sort: 13},
          {sort: 15},
          {sort: 17}
        ],
        tableLoading: false
      };
    },

    computed: {},

    created() {
    },

    methods: {
      showDialog() {
        this.dialogShow = true;
      },
      handleCurrentChange(val) {
        this.currentRow = val;
      },
      submit() {
      },
      changeOrder(index) {
        console.log(index);
        let obj = {id: 12, sort: this.list[index].sort};
        alert(JSON.stringify(obj));
      },
      clickEdit() {
        if (!this.currentRow) {
          tool.message("请在表格中选择数据", "error");
          return;
        }
        this.dialogShow = true;
      },
      del() {
        if (!this.currentRow) {
          tool.message("请在表格中选择数据", "error");
        } else {
          this.$confirm("确定要删除吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(() => {
            this.$message({
              type: "success",
              duration: 1000,
              message: "操作成功!",
              onClose: () => {
                this.getData();
              }
            });
          });
        }
      }
    },

    components: {}
  };
</script>

<style lang="less" rel="stylesheet/less">
  .system-auth-container {
    width: 100%;
    height: auto;
    display: flex;
    padding: 15px;
    flex-direction: column;
  }
</style>
